import { circledTick } from "../assets/icons";
import { plans } from "../utils/static";

function Pricing({ scroll }) {
  return (
    <div
      id="pricing"
      className="w-full h-fit flex flex-col justify-center items-center gap-16 bg-gradient-to-t from-purp to-white text-black mt-32 p-8"
    >
      <div className="w-full h-fit flex flex-col gap-8">
        <div className="w-full flex flex-col items-center gap-4">
          <h6 className="text-center text-[22px] smd:text-[32px] md:text-[38px] xxl:text-[48px] font-bold leading-tight flex flex-col">
            <span>Pricing</span>
            {/* <span>Choose your plan, enjoy your benefits</span> */}
          </h6>

          {/* <p className="max-w-[600px] text-center text-sm smd:text-base md:text-lg text-gray-600 font-bold">
            We offer flexible solutions, affordable plans and value with
            versatility.
          </p> */}
        </div>
      </div>

      <div className="w-full flex flex-wrap justify-center items-center gap-8 pb-32">
        {plans.map((plan, index) => (
          <div
            key={index}
            className="group w-full smd:w-[650px] h-fit flex flex-col gap-8 justify-between text-black hover:text-white bg-white shadow-lg hover:bg-teal rounded-lg hover:scale-105 p-8 duration-500"
          >
            <div className="w-full flex items-center justify-between gap-4 pb-8 border-b border-b-teal/50 group-hover:border-b-white duration-500">
              <p className="text-center text-lg smd:text-2xl font-semibold text-black group-hover:text-white duration-500">
                {plan.name}
              </p>

              {/* <p className="text-xs border border-teal/50 group-hover:border-white rounded-full px-2 py-1 text-teal/50 group-hover:text-white duration-500">
                MOST POPULAR
              </p> */}
            </div>

            {/* <h6 className="text-[12px] font-bold text-center flex justify-center items-center gap-1 mt-4">
              {plan.price}
              <span className="text-base font-semibold text-gray-400 group-hover:text-white/60 duration-500">
                / Month
              </span>
            </h6>
            <p className="text-xs text-gray-400 group-hover:text-white/50 text-center duration-500 my-4">
              {plan.note}
            </p> */}

            <div className="w-full flex flex-wrap md:justify-center gap-4">
              {plan.features.map((feature, index) => (
                <p
                  key={index}
                  className="w-[260px] flex items-center gap-2 text-sm font-semibold"
                >
                  <span
                    className={`w-4 ${
                      feature.status ? "text-green-400" : "text-gray-400"
                    }`}
                  >
                    {circledTick}
                  </span>
                  {feature.name}
                </p>
              ))}
            </div>

            <div className="w-full flex justify-end pt-8 border-t border-t-teal/50 group-hover:border-t-white duration-500">
              <button
                onClick={() => scroll("contactus")}
                className="px-4 py-2 rounded-full text-sm font-semibold bg-purp text-white group-hover:text-black group-hover:bg-white duration-500"
              >
                Contact Us
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Pricing;
